import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ElderIntroPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const name = localStorage.getItem("kinkeeperName");
  const email = localStorage.getItem("kinkeeperEmail");
  const relationship = localStorage.getItem("relationship");

  useEffect(() => {
    if (!name || !email) {
      navigate("/elder-login");
    }
  }, [name, email, navigate]);

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content">
          <div className="identity-card">
            <div className="avatar-ring">{name?.charAt(0) || "K"}</div>

            <div>
              <div className="intro-badge">{t("intro.badge")}</div>
              <h1 className="page-title">{t("intro.title")}</h1>
              <p className="page-subtitle">
                {t("intro.subtitle", { name, relationship })}
              </p>
              <div className="pill-row">
                <span className="soft-pill">{t("intro.trustedContact")}</span>
                <span className="soft-pill">{t("intro.clearNextStep")}</span>
              </div>
            </div>
          </div>

          <div className="details-grid section-block">
            <div className="detail-card">
              <div className="field-label">{t("intro.kinkeeperName")}</div>
              <div className="detail-value">{name}</div>
            </div>
            <div className="detail-card">
              <div className="field-label">{t("intro.contactEmail")}</div>
              <div className="detail-value">{email}</div>
            </div>
            <div className="detail-card">
              <div className="field-label">{t("intro.relationship")}</div>
              <div className="detail-value">{relationship}</div>
            </div>
          </div>

          <div className="support-card section-block" style={{ minHeight: "auto" }}>
            <div>
              <div className="mini-label">{t("intro.whatThisMeans")}</div>
              <h3>{t("intro.notAlone")}</h3>
              <p>
                {t("intro.notAloneText")}
              </p>
            </div>
          </div>

          <div className="button-row">
            <button className="ghost-button" onClick={() => navigate("/elder-login")}>
              ← Back to sign in
            </button>
            <button className="warm-button" onClick={() => navigate("/elder-map")}>
              {t("intro.btnContinue")} →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ElderIntroPage;
